import {Race} from "./race";
import {Organiser} from "./organizer";
import {CompetitorCount} from "./competitor-count";
import {EventPaymentSettings} from "./event-payment-settings";
import {PhoneNumber} from "./phone-number";

export class EventItem {
  id?: number;
  organiserId?: number;
  name?: string;
  nameEng?: string;
  nameIta?: string;
  nameSlo?: string;
  status?: number;
  start?: Date;
  end?: Date;
  image?: string;
  imageIcon?: string;
  imageMini?: string;
  imageSmall?: string;
  imageMedium?: string;
  created?: Date;
  modified?: Date;
  startTo?: Date;
  racesList?: Race[];
  finished?: boolean;
  open?: boolean;
  competitorCount?: CompetitorCount;
  organiser?: Organiser;
  favorite?: boolean
  latitude?: number;
  longitude?: number;
  leagueName?: string;
  leagueNameEn?: string;
  leagueNameIt?: string;
  leagueNameSl?: string;
  defaultLanguage?: number;
  currency?: number;
  country?: number;
  city?: string;
  sportOne?: number;
  sportTwo?: number;
  extraLanguages?: number[];
  leagueId?: number;
  round?: number;
  eventType?: number;
  eventTags?: string[];
  locationExtraTag?: string;
  titleImage?: string;
  paymentSettings?: EventPaymentSettings;
  originalEventId?: number;
  description?: string;
  descriptionEng?: string;
  descriptionSlo?: string;
  descriptionIta?: string;
  descriptionImage?: string;
  rules?: string;
  rulesEng?: string;
  rulesSlo?: string;
  rulesIta?: string;
  rulesImage?: string;
  discountApplied?: boolean;
  lengths?: string[];
  measurementByStotinka?: boolean;
  phoneNumbers?: PhoneNumber[];
  awardFund?: string;
  awardFundEng?: string;
  awardFundIta?: string;
  awardFundSlo?: string;
  mediaContentHor?: string;
  mediaContentHorEng?: string;
  mediaContentHorIta?: string;
  mediaContentHorSlo?: string;
  mediaContentVideoHor?: string;
  mediaContentVert?: string;
  mediaContentVertEng?: string;
  mediaContentVertIta?: string;
  mediaContentVertSlo?: string;
  mediaContentVideoVert?: string;
  infoEmail?: string;
  // Number of countries from which competitors are coming to the event
  competitorCountriesCnt?: number;
  // Number of competitors who finished the race in event
  finCompetitorCnt?: number;
  commonStartNumber?: boolean;
}
